// extracted by mini-css-extract-plugin
export default {"select":"pool-section_select__vOA46"};